import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Sparkline({ accountId, negative }) {
  const [pts, setPts] = useState(null);
  useEffect(() => {
    api.get(`/accounts/${accountId}/sparkline`).then(r => setPts(r.data.points)).catch(() => setPts([]));
  }, [accountId]);
  if (!pts || pts.length < 2) return <div className="w-24 h-8" />;
  const values = pts.map(p => Math.abs(p));
  const min = Math.min(...values), max = Math.max(...values);
  const range = max - min || 1;
  const w = 96, h = 32;
  const step = w / (values.length - 1);
  const points = values.map((v, i) => `${(i * step).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`).join(" ");
  const trend = values[values.length - 1] - values[0];
  const trendUp = negative ? trend < 0 : trend > 0;
  const color = trendUp ? "#2A9D8F" : "#E06A3B";
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-24 h-8 shrink-0" data-testid={`sparkline-${accountId}`}>
      <defs>
        <linearGradient id={`g-${accountId}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={points} />
      <polygon fill={`url(#g-${accountId})`} points={`0,${h} ${points} ${w},${h}`} />
    </svg>
  );
}
